import { Typography, AccordionDetails } from "@mui/material"
import { useCallback } from "react"

import { DynamicConfigurableFormField } from "src/components/ConfigurableDynamicFormFields/formFields"
import { PublicAgentCodeSnippets } from "src/components/ConfigurableDynamicFormFields/components/PublicAgentCodeSnippets"

import { config_FieldType } from "src/api/models/config_FieldType"
import { IConfigurableSectionContentProps } from "src/components/ConfigurableDynamicFormFields/types/configurable-section"

export const ConfigurableSectionContent = ({
    sectionConfigurableFields,
    sectionName,
}: IConfigurableSectionContentProps) => {
    const getKey = (fieldName?: string) => `${sectionName}-${fieldName}`
    const showFieldNameAsHeading = useCallback(
        (type?: config_FieldType) =>
            type === "file" ||
            type === "icon" ||
            type === "image" ||
            type === "text_list" ||
            type === "auto_uuid",
        [],
    )

    // Filter out fields that should be hidden in admin
    const visibleFields = sectionConfigurableFields.filter(
        (field) => field.hide_in_admin !== true,
    )

    // Check if this section is for public_agent and has auto_uuid field (even if hidden)
    const isPublicAgentSection = sectionName === "public_agent"
    const hasAutoUuidField = sectionConfigurableFields.some(
        (field) => field.type === "auto_uuid",
    )

    return (
        <>
            {visibleFields.map((field) => {
                return (
                    <AccordionDetails sx={{ mb: 3 }} key={getKey(field.name)}>
                        {showFieldNameAsHeading(field.type) && (
                            <Typography variant="subtitle2" gutterBottom>
                                {field.label}
                            </Typography>
                        )}
                        <Typography variant="body1" gutterBottom mb={2}>
                            {field.description}
                        </Typography>
                        <DynamicConfigurableFormField
                            sectionName={sectionName}
                            field={field}
                            key={getKey(field.name)}
                        />
                    </AccordionDetails>
                )
            })}
            {isPublicAgentSection && hasAutoUuidField && (
                <AccordionDetails>
                    <PublicAgentCodeSnippets sectionName={sectionName} />
                </AccordionDetails>
            )}
        </>
    )
}
